import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import SignupApp from "./SignupApp";
import LoginApp from "./LoginApp";
import * as serviceWorker from "./serviceWorker";
import { getStorageData, clearStorageData } from "./utils";
import { Actions } from "./reducers/Context";

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// (async () => {
//     console.log('init storage');
//     await initStorageData('tsStorageData');
// })();

const methodNotImplemented = () => {
  alert("method not implemented");
};

window.tsUtilityModals = {
  initialiseSignup: (divId) => {
    ReactDOM.render(<SignupApp />, document.getElementById(divId));
  },
  onSignupComplete: (callback) => {
    if (typeof callback === "function") {
      window.tsUtilityModals.signupCompleteCallback = callback;
    }
  },
  onSignupCancel: (callback) => {
    if (typeof callback === "function") {
      window.tsUtilityModals.signupCancelCallback = callback;
    }
  },
  signupCompleteCallback: methodNotImplemented,
  signupCancelCallback: methodNotImplemented,
  initialiseLogin: async (divId) => {
    ReactDOM.render(<LoginApp />, document.getElementById(divId));
  },
  logOut: (divId) => {
    clearStorageData();
  },
  onLoginComplete: (callback) => {
    if (typeof callback === "function") {
      window.tsUtilityModals.loginCompleteCallback = callback;
    }
  },
  onLoginCancel: (callback) => {
    if (typeof callback === "function") {
      window.tsUtilityModals.loginCancelCallback = callback;
    }
  },
  loginCompleteCallback: methodNotImplemented,
  loginCancelCallback: methodNotImplemented,
  getStorageData,
};

if (typeof window.tsUtilityModalsLoaded === "function") {
  window.tsUtilityModalsLoaded();
}

if (window.location.host.indexOf("al.teamstats.net") === 0) {
  window.tsUtilityModals.initialiseSignup("root");
  // window.tsUtilityModals.initialiseLogin('root');
}
